import React from 'react';
import styles from './creativesHome.module.scss';
import { RecentGroupDropdown } from 'components/RecentGroupDropdown/RecentGroupDropdown';
import { CreativesHomeProps } from './CreativesHomeModel';
import i18n from 'i18next';
import { CreativeList } from '../CreativeList/CreativeList';
import { SessionStorageItemKeys } from 'helper/StorageHelper';
import { RouteComponentProps } from 'react-router-dom';
import _ from 'lodash';
import PermissionChecker from 'containers/PermissionChecker/PermissionChecker';
import { notRoles, hasRoles } from 'core/permission/PermissionDSL';
import { RoleNames } from 'core';
import { CreativeErrorsModal } from 'components/CreativeErrorsModal/CreativeErrorsModal';

export class CreativesHome extends React.Component<RouteComponentProps<any> & CreativesHomeProps> {

  handler?: number;

  componentDidMount () {
    this.handler = this.props.model.event.add((model) => {
      this.setState(model.state);
    });
    this.props.model.init();
  }

  componentDidUpdate (prevProps) {
    if (prevProps.model !== this.props.model) {
      prevProps.model.event.remove(this.handler);
      this.handler = this.props.model.event.add((model) => {
        this.setState(model.state);
      });
      this.props.model.init();
    }
  }

  componentWillUnmount () {
    this.handler && this.props.model.event.remove(this.handler);
  }

  onAgencySelected = (agencyId?: number) => {
    this.props.model.setAgencyId && this.props.model.setAgencyId(agencyId);
  }

  onAdvertiserSelected = (advertiserId?: number) => {
    this.props.model.setAdvertiserId(advertiserId);
  }

  replaceSearchParams = (searchParams: URLSearchParams) => {
    const queryString = searchParams.toString();
    this.props.history.replace(queryString ? `${this.props.location.pathname}?${queryString}` : this.props.location.pathname);
  }

  onSearchChange = (searchPath) => {
    const searchParams = new URLSearchParams(this.props.location.search);
    if (_.isEmpty(searchPath)) {
      searchParams.delete('creativeSearch');
    } else {
      searchParams.set('creativeSearch', searchPath);
    }
    this.replaceSearchParams(searchParams);
  }

  onCreativeTypeChange = (creativeType: number) => {
    const searchParams = new URLSearchParams(this.props.location.search);
    searchParams.set('type', String(creativeType));
    this.replaceSearchParams(searchParams);
  }

  renderCreateCreativeError = (errors) => {
    return <CreativeErrorsModal errors={errors}/>;
  }

  render () {
    const searchParams = new URLSearchParams(this.props.location.search);
    const model = this.props.model;
    const locationState = this.props.location.state;
    const createCreativeErrors: any[] = _.get(locationState, 'errors', []);
    return (
      <div className={styles.container}>
        <div className={styles.titleArea}>
          {i18n.t<string>('creativesHome.labels.title')}
          <div className={styles.filterArea}>
            <PermissionChecker permissionAware={hasRoles(RoleNames.sysAdmin)}>
              <div className={styles.agencyList}>
                <div className={styles.title}>
                  {i18n.t<string>('creativesHome.labels.agencyListTitle')}
                </div>
                <RecentGroupDropdown
                  value={model.state.agencyId}
                  options={model.state.agencies}
                  storageKey={SessionStorageItemKeys.AGENCY}
                  callback={this.onAgencySelected}
                />
              </div>
            </PermissionChecker>
            <PermissionChecker
              permissionAware={notRoles(RoleNames.adsAdmin, RoleNames.adsReport, RoleNames.adsSales)}
            >
              <div className={styles.advertiserList}>
                <div className={styles.title}>
                  {i18n.t<string>('creativesHome.labels.advertiserListTitle')}
                </div>
                <RecentGroupDropdown
                  value={model.state.advertiserId}
                  options={model.advertisers}
                  storageKey={SessionStorageItemKeys.ADVERTISER}
                  callback={this.onAdvertiserSelected}
                />
              </div>
            </PermissionChecker>
          </div>
        </div>
        <div className={styles.listArea}>
          <CreativeList model={this.props.model.getCreativeListModel(searchParams.get('creativeSearch'), this.onSearchChange, searchParams.get('type'), this.onCreativeTypeChange)}/>
        </div>
        {createCreativeErrors && createCreativeErrors.length > 0 && this.renderCreateCreativeError(createCreativeErrors)}
      </div>
    );
  }
}
